<template>
  <Transition
    enter-active-class="motion-safe:transition-all motion-safe:duration-200 motion-safe:ease-out"
    enter-from-class="opacity-0 scale-95"
    enter-to-class="opacity-100 scale-100"
    leave-active-class="motion-safe:transition-all motion-safe:duration-200 motion-safe:ease-in"
    leave-from-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-95"
  >
    <button
      v-if="show"
      class="group rounded-md items-center p-8 lg:bg-static-info-mid motion-safe:transition-all motion-safe:duration-200 motion-safe:ease-in-out"
      :class="[
        {
          'text-static-default-hi cursor-pointer lg:hover:!bg-static-info-mid-hover':
            !disabled || checked,
          'text-static-default-hi-disabled cursor-not-allowed lg:!bg-static-info-mid-disabled':
            disabled && !checked,
        },
        isResponsiveModeEnabled ? 'flex' : 'hidden lg:flex',
      ]"
      :disabled="disabled && !checked"
      @click.stop.prevent="handleClick"
    >
      <Transition
        appear
        enter-active-class="motion-safe:[transition:max-width_300ms_ease-in-out,opacity_100ms]"
        enter-from-class="max-w-[0px] opacity-0"
        enter-to-class="max-w-[400px] opacity-100"
      >
        <span
          class="body-2-bold mx-8 hidden overflow-hidden whitespace-nowrap lg:inline"
        >
          {{ i18n(translations[checked ? 'clear' : 'compare']) }}
        </span>
      </Transition>
      <IconCheckInCircleFilled v-if="checked" size="32" />
      <IconCircle v-else size="32" />
    </button>
  </Transition>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'
import { IconCircle } from '@ds/icons/IconCircle'

import translations from './ProductComparisonCheckbox.translations'

const {
  disabled = false,
  show = true,
  isResponsiveModeEnabled = false,
} = defineProps<{
  checked: boolean
  disabled?: boolean
  show?: boolean
  isResponsiveModeEnabled?: boolean
}>()

const i18n = useI18n()

const emit = defineEmits(['change'])

function handleClick() {
  emit('change')
}
</script>
